export default __webpack_public_path__ + "static/media/roboto-v20-latin-300italic.bd5b7a13.woff";